// src/data/subscriptionPlans.js
export const subscriptionPlans = [
  {
    id: 'monthly',
    name: 'Månedligt abonnement',
    description: 'Fuld adgang til alt premium-indhold',
    price: 30,
    currency: 'DKK',
    interval: 'month',
    features: [
      'Reklamefri lytning',
      'Eksklusivt indhold',
      'Støt dine foretrukne skabere direkte',
      'Tidlig adgang til nye episoder'
    ]
  }
];